export const SET_BASE_CONFIGURATION = 'SET_BASE_CONFIGURATION';
export const SET_CONFIGURATION_NEIGHBORS = 'SET_CONFIGURATION_NEIGHBORS';
export const SET_INVESTOR_RATES_USED = 'SET_INVESTOR_RATES_USED';
export const SET_INVESTOR_UPDATES = 'SET_INVESTOR_UPDATES';
export const SET_IS_TERSE_LOADING = 'SET_IS_TERSE_LOADING';
export const SET_RATES = 'SET_RATES';
export const SET_ELIGIBILITY_MATRIX_RULES = 'SET_ELIGIBILITY_MATRIX_RULES';
export const SET_TERSE_CONFIGURATION = 'SET_TERSE_CONFIGURATION';
export const SET_AUDIENCES = 'SET_AUDIENCES';
export const SET_IS_AUDIENCES_LOADING = 'SET_IS_AUDIENCES_LOADING';

export default {
  SET_BASE_CONFIGURATION,
  SET_CONFIGURATION_NEIGHBORS,
  SET_INVESTOR_RATES_USED,
  SET_INVESTOR_UPDATES,
  SET_IS_TERSE_LOADING,
  SET_RATES,
  SET_ELIGIBILITY_MATRIX_RULES,
  SET_TERSE_CONFIGURATION,
  SET_AUDIENCES,
  SET_IS_AUDIENCES_LOADING,
};
